import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './inline-list.scss';

const InlineListItem = ({
  children,
  isTitle,
  href,
  anchorAttributes,
  lastItem,
}) => {
  const className = classnames('sm-inline-list__item', {
    'sm-inline-list__item--title': isTitle === true,
  });

  const showBullet = !isTitle && !lastItem;

  return (
    <li className={className}>
      <Choose>
        <When condition={href}>
          <a
            className="sm-inline-list__item-anchor"
            href={href}
            {...anchorAttributes}
          >
            {children}
          </a>
          <If condition={showBullet}>
            <span className="sm-inline-list__item-bullet">&bull;</span>
          </If>
        </When>
        <Otherwise>{children}</Otherwise>
      </Choose>
    </li>
  );
};

InlineListItem.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
  anchorAttributes: PropTypes.shape({
    rel: PropTypes.string,
  }),
  isTitle: PropTypes.bool,
  lastItem: PropTypes.bool,
};

InlineListItem.defaultProps = {
  href: '',
  children: '',
  anchorAttributes: null,
  isTitle: false,
  lastItem: false,
};

export default InlineListItem;
